"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const actionSchema = Yup.object().shape({
  service: Yup.string().required("Please select one service"),
  method: Yup.string().required("Please select one action"),
  waitForAction: Yup.string(),
  params: Yup.object().required()
});
class ActionNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    //console.log(JSON.parse(JSON.stringify(selectedResource)));
    return helper_1.isValid(
      [
        { schema: actionSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        {
          schema: IValidation_1.selectedResourceSchema,
          data: JSON.parse(JSON.stringify(selectedResource))
        }
      ],
      node.getNodeId()
    );
  }
}
exports.ActionNodeValidation = ActionNodeValidation;
//# sourceMappingURL=ActionNodeValidation.js.map
